module.exports = __webpack_public_path__ + "static/img/11.c770688.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/sp/11.png
// module id = d4Y2
// module chunks = 0